import Dexie from 'dexie';
import {
  SnapshotItem,
  SnapshotStores,
  snapshotStoresSchema,
  walStoresSchema
} from '../../types';
import { decrypt } from '../../../../core/cryptor/cipher';
import { getInitialSnapshotInfo, getWALDBName } from '../../helpers';

export async function getDecryptedSnapshotInfo(db: Dexie, feKey: CryptoKey) {
  const encSnapshotInfo = await db
    .table(SnapshotStores.Snapshot)
    .get(SnapshotItem.Info);
  const decSnapshotInfo = encSnapshotInfo
    ? await decrypt(encSnapshotInfo, feKey)
    : '';
  return decSnapshotInfo
    ? JSON.parse(decSnapshotInfo)
    : getInitialSnapshotInfo();
}

export async function getSnapshotDB(id: string) {
  // const t1 = performance.now()
  const db = new Dexie(id);
  db.version(1).stores(snapshotStoresSchema);
  await db.open();

  // const t2 = performance.now()


  // console.log("idb performance", t2 - t1, id)

  return db;
}

export async function getWALDB(id: string, activeWAL: number) {
  const name = getWALDBName(id, activeWAL);
  const db = new Dexie(name);
  db.version(1).stores(walStoresSchema);

  await db.open();
  return db;
}

export async function getWALDBIfExists(id: string, activeWAL: number) {
  const name = getWALDBName(id, activeWAL);
  const isExist = await Dexie.exists(name);

  let db: Dexie | undefined = undefined;
  if (isExist) {
    db = new Dexie(name);
    db.version(1).stores(walStoresSchema);
    await db.open();
  }

  return {
    isExist,
    db,
  };
}